export class AnnouncementDto {
    id;
    message;
    media = [];
    mentions = [];
    createdById;
    createdBy;
    createdAt;
    annoucementComments = [];
    commentCount;
    get images() {
        return this.media.filter((m) => m.type === "Image");
    }
    get videos() {
        return this.media.filter((m) => m.type === "Video");
    }
    get documents() {
        return this.media.filter((m) => m.type === "Document");
    }
    constructor(obj) {
        Object.assign(this, obj);
    }
    static create(obj) {
        return new AnnouncementDto(obj);
    }
}
//# sourceMappingURL=AnnouncementDto.js.map